import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MaintenanceService } from 'src/app/modules/maintenance/services/maintenance.service';

@Injectable()
export class MaintenanceGuard implements CanActivate {
    constructor(
        private router: Router,
        private maintenanceService: MaintenanceService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.maintenanceService.inMaintenance$.pipe(
            filter(
                (isInMaintenance: boolean | null): boolean =>
                    isInMaintenance !== null
            ), // Ignore null values
            map((isInMaintenance: boolean): boolean | UrlTree => {
                if (isInMaintenance) {
                    // Redirect to a maintenance page or return false to prevent navigation
                    return this.router.parseUrl('/maintenance');
                } else {
                    // Allow navigation
                    return true;
                }
            })
        );
    }
}
